import { RootState } from '../../config';
import { ModalName } from '../../enums';

export const selectModalByName = (state: RootState, modalName: ModalName) => state.modals[modalName];
